import { render, staticRenderFns } from "./AddNewPowerGuardQuestionGroup.vue?vue&type=template&id=6c6cc464&"
import script from "./AddNewPowerGuardQuestionGroup.vue?vue&type=script&lang=js&"
export * from "./AddNewPowerGuardQuestionGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports